export default __webpack_public_path__ + "static/use-1-pt-cd4d5ba5786dc7ef60acce88c0e339a5.png";